import React from "react";
import { useTranslation } from "react-i18next";

import styles from "../NotesPage.module.scss";
import moment from 'moment';
import { patchNotesData, patchNotesTitleData } from "service/NotesService";

const ShowItems = ({ id, title, body, createdAt, action }) => {
  const { t } = useTranslation('common');
  const formatDate = (dateString) => { 
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();
  
    if (date.isSame(today, 'day')) {
      return t('notes.today');
     }
     else if (date.isBefore(today, 'day')) {
      return `${t('notes.created_word')} ${date.format('DD MMMM YYYY')}`;
    }
    else if(date.isSame(today, 'year')){
      return `${t('notes.created_word')} ${date.format('DD MMMM')}`;
     }
    else {
      return `${t('notes.created_word')} ${date.format('DD MMMM YYYY')}`;
    }
};

const handleChangeNoteData = async (e, id) => {
  const { target } = e;
  const { value } =  target;
  await patchNotesData(id, value);
  action((notes) =>
    notes.map((note)  => {
      if (note.id === id) {
        return { ...note, body:value };
      }
      return note;
    }));
  }
    
  
  

  return (
    <div className={styles["note-item__content"]}>
      
      
      <p className={styles["note-item__date"]}>{formatDate(createdAt)}</p>
      
      <textarea
      className={styles["note-item__body"]}
              onChange={(e) => handleChangeNoteData(e, id)}
              name="body"
              defaultValue={body}
              placeholder={t('notes.my_note_placeholder')}
            ></textarea>
      
    </div>
  );
};

export default ShowItems;
